import CarouselNavigation from './CarouselNavigation';

export default CarouselNavigation;
